module.exports = __webpack_public_path__ + "img/cjcx.41f746e9.png";